import React from 'react';
import { motion } from 'framer-motion';
export const ProductPresentation = () => {
  return <section className="py-24 bg-cream relative overflow-hidden" data-id="element-263">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-264">
        <div className="text-center mb-16" data-id="element-265">
          <span className="text-brand-600 font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-266">
            — LA SOLUCIÓN —
          </span>
          <h2 className="text-5xl sm:text-6xl font-bold text-neutral-900 mb-6 tracking-tight" data-id="element-267">
            CAJA DE COBRO
          </h2>
          <p className="text-2xl sm:text-3xl font-medium text-neutral-700 text-balance" data-id="element-268">
            El Sistema para Generar Ventas cuando "Nadie tiene un Mango"
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-269">
          {/* Esto NO es */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl p-8 border border-neutral-200 shadow-sm" data-id="element-270">
            <h3 className="text-xl font-bold text-neutral-700 mb-6" data-id="element-271">
              Esto NO es:
            </h3>
            <ul className="space-y-4" data-id="element-272">
              <li className="flex items-start gap-3 text-neutral-600" data-id="element-273">
                <span className="mt-1" data-id="element-274">❌</span>
                <span data-id="element-275">Un curso de motivación con frases bonitas</span>
              </li>
              <li className="flex items-start gap-3 text-neutral-600" data-id="element-276">
                <span className="mt-1" data-id="element-277">❌</span>
                <span data-id="element-278">Un ebook genérico traducido del inglés</span>
              </li>
              <li className="flex items-start gap-3 text-neutral-600" data-id="element-279">
                <span className="mt-1" data-id="element-280">❌</span>
                <span data-id="element-281">Teoría de negocios que no se aplica</span>
              </li>
            </ul>
          </motion.div>

          {/* Esto SÍ es */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-brand-600 rounded-xl p-8 shadow-md" data-id="element-282">
            <h3 className="text-xl font-bold text-white mb-6" data-id="element-283">Esto SÍ es:</h3>
            <ul className="space-y-4" data-id="element-284">
              <li className="flex items-start gap-3 text-brand-50" data-id="element-285">
                <span className="mt-1" data-id="element-286">✅</span>
                <span className="font-medium" data-id="element-287">
                  Un manual táctico de implementación inmediata
                </span>
              </li>
              <li className="flex items-start gap-3 text-brand-50" data-id="element-288">
                <span className="mt-1" data-id="element-289">✅</span>
                <span className="font-medium" data-id="element-290">
                  Diseñado para el profesional argentino de 2026
                </span>
              </li>
              <li className="flex items-start gap-3 text-brand-50" data-id="element-291">
                <span className="mt-1" data-id="element-292">✅</span>
                <span className="font-medium" data-id="element-293">
                  Con palabras exactas y scripts copiables
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
};